/**
  Author - Muhamed Afsal
  Git - https://bitbucket.org/mohdafsal/
**/

"use strict";

const openScheduler = (url) => {
  const Calendly = window.Calendly;
  Calendly.initPopupWidget({url});
  return false;
};

export default openScheduler;
